import styled, { css } from 'styled-components';
import { iconSize } from './icon-components';

const VolumeButtonBorder = css`
  box-shadow: inset -10px -10px 10px -10px rgba(0, 0, 0, 0.75), inset 10px 10px 12px -10px rgba(255, 255, 255, 0.75)
`;

export const VolumeProgramBorder = css`
  box-shadow: inset 0px 10px 16px -10px rgba(255, 255, 255), inset -10px -10px 15px -8px rgba(0, 0, 0, 0.75), inset 10px -10px 15px -8px rgba(0, 0, 0, 0.75)
`;

export const Button = styled.button<ButtonProps>`
  --background-color: ${({ color }) => color};
  all: unset;
  
  position: relative;
  width: ${iconSize - 0.4}vmin;
  height: ${iconSize- 0.4}vmin;
  padding: 0.4vmin;
  margin: 0.2vmin;
  margin-bottom: 0.2vmin;
  background-color: var(--background-color);
  border-radius: 0.4vmin;
  border: 0.17vmin solid white;

  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  opacity: ${({ disabled }) => disabled ? '0.7' : '1'};
  ${VolumeButtonBorder};
  
  &:hover {
    ${({ disabled }) => disabled ? '' : 'box-shadow: inset 0 0 0 100px rgba(0, 0, 0, 0.3)'};
  }
  
}
`;

interface ButtonProps {
	color: string;
	disabled: boolean;
}
